import React, { useState, useEffect } from 'react';
import { AppBar, Toolbar, Typography, Box, ListItemButton, ListItemText } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';

const Header: React.FC = () => {
  const [time, setTime] = useState(new Date().toLocaleString());
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    const timer = setInterval(() => {
      setTime(new Date().toLocaleString());
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('role');
    navigate('/login');
  };

  if (location.pathname === '/login') return null;

  return (
    <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
      <Toolbar>
        <Typography variant="h6" sx={{ flexGrow: 1 }}>
          Backoffice
        </Typography>
        <Typography>{time}</Typography>
        <Typography>
        <ListItemButton
              onClick={() =>
                handleLogout()
              }
            >
              <ListItemText primary={"Logout"} />
            </ListItemButton>
        </Typography>
      
      </Toolbar>
    </AppBar>
  );
};

export default Header;